<template>
  <b-container class="search-area" fluid="lg">
    <div class="mb-3">
      <b-form-row class="mb-4">
        <b-col class="form-group">
          <h3 class="common__search-title">Tutor</h3>
          <input
            v-model="conditions.tutorNameOrId"
            type="text"
            class="form-control w-50"
          >
        </b-col>
        <b-col>
          <h3 class="common__search-title">Position</h3>
          <Position v-model="conditions.positions"/>
        </b-col>
      </b-form-row>

      <b-form-row class="mb-4">
        <b-col class="form-group">
          <h3 class="common__search-title">Gender</h3>
          <Gender v-model="conditions.genders"/>
        </b-col>
        <b-col class="form-group">
          <h3 class="common__search-title">Year</h3>
          <FiscalYearInput
            v-model="conditions.year"
            class="form-control w-50"
          />
        </b-col>
      </b-form-row>

      <b-form-row class="mb-4">
        <b-col class="form-group">
          <h3 class="common__search-title">Nationality</h3>
          <Nationality
            v-model="conditions.nationality"
            class="form-control w-25"
          />
        </b-col>
      </b-form-row>
    </div>
    <div class="d-flex justify-content-end">
      <b-button
        pill
        variant="secondary"
        @click="reset"
        class="mr-2"
      >
        Reset
      </b-button>
      <b-button
        pill
        variant="primary"
        @click="search"
      >
        Search
      </b-button>
    </div>
  </b-container>
</template>

<script lang="ts">
import Vue from 'vue'
import Position from '@/components/parts/inputItem/PositionsInput.vue';
import Gender from '@/components/parts/inputItem/GendersInput.vue';
import Nationality from '@/components/parts/inputItem/NationalityInput.vue';
import FiscalYearInput from '@/components/parts/inputItem/FiscalYearInput.vue';
import _ from 'lodash';
import { EvaluationConditions } from '@/store/evaluations/types'

// 検索の初期設定値
const initialConditions: EvaluationConditions = {
  tutorNameOrId: null,
  positions: [],
  year: null,
  genders: [],
  nationality: null,
}

export default Vue.extend({
  data() {
    return {
      conditions: _.cloneDeep(initialConditions),
    }
  },
  components: {
    Position,
    Gender,
    Nationality,
    FiscalYearInput,
  },
  mounted() {
    this.conditions = _.cloneDeep(initialConditions)
  },
  methods: {
    // 検索ボタン押下時、親のsearch処理を走らせる
    search() {
      this.$emit('search', this.conditions)
    },
    // リセットボタン押下時各inputの中身を削除し、親のreset処理を走らせる
    reset() {
      this.conditions = _.cloneDeep(initialConditions)
      this.search()
    },
  },
})
</script>

<style scoped>
</style>
